import Column from '@/util/NewWorldColumn';
import ColumnName from '@/util/ColumnName';
import { identity, map } from 'ramda';
import { mapObject } from '@/util/helpers/object-helpers';
import { useLoadColumns } from '..';

export const useLoadColumns_LEGACY = (
  skip = false,
  additionalParams: {
    layerInEditModeId?: number;
    stepInEditModeIndex?: number;
    includeHidden?: boolean;
  } = {},
) => {
  const { data, ...rest } = useLoadColumns(skip, additionalParams);
  let state: {
    columnsByLayerId: Record<number, Column[]>;
    allColumns: Maybe<Column[]>;
    headings: Maybe<Column[]>;
  } = {
    headings: null,
    allColumns: null,
    columnsByLayerId: {},
  };

  if (data) {
    const visible = data._selected.map(ColumnName.build);
    const allColumns = data._columns.map(Column.build);
    const columnsByLayerId = mapObject(
      data._columnsByLayerId,
      identity,
      map(Column.build),
    ) as Record<number, Column[]>;

    const headings = allColumns.filter((c: Column) =>
      visible.find((v: ColumnName) => v.equals(c.name())),
    );

    state = {
      headings,
      allColumns,
      columnsByLayerId,
    };
  }

  return { ...state, ...rest } as const;
};
